import React from 'react';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import NoRows from '@/components/table/NoRows';
import fetch, { fetchConfig } from '@/hooks/fetch';
import WorkspaceAllowListCondition, {
  validateWorkspaceAllowListContext,
} from './WorkspaceAllowListCondition';
import WorkspaceAllowListLabelGroup from '../components/WorkspaceAllowListLabelGroup';
import DatasetConditionsDropdown from '../components/DatasetConditionsDropdown';
import { fetchConditions, updateActiveDatasetCondition } from '../actions';
import { availableDatasetConditions } from '../state/state';
import UserDefinedRestrictionInfo from '../components/UserDefinedRestrictionInfo';
import UserDefinedRestrictionPicker, { validateUserDefinedRestriction } from './UserDefinedRestrictionPicker';
import WorkspaceLocationsCondition, { validateWorkspaceLocationsContext } from './WorkspaceLocationsCondition';
import WorkspaceLocationsLabelGroup from './WorkspaceLocationsLabelGroup';

export const datasetConditionComponents = {
  'ADDUC:0005': {
    editor: UserDefinedRestrictionPicker,
    info: UserDefinedRestrictionInfo,
    validator: validateUserDefinedRestriction,
  },
  'ADDUC:0006': {
    editor: WorkspaceAllowListCondition,
    info: WorkspaceAllowListLabelGroup,
    validator: validateWorkspaceAllowListContext,
  },
  'ADDUC:0007': {
    editor: WorkspaceLocationsCondition,
    info: WorkspaceLocationsLabelGroup,
    validator: validateWorkspaceLocationsContext,
  },
};

const DatasetConditionForm = ({
  changeCondition,
  conditions,
  fetchData,
  isNew,
  readStatus,
  saveErrors,
  saveStatus,
  selectedCondition,
}) => {
  fetch.useFetch(fetchData, readStatus, fetchConfig([readStatus]));
  const FieldComponent = datasetConditionComponents[selectedCondition.code]?.editor;
  const hasConditions = readStatus === states.SUCCESS && conditions.length > 0;

  const onChangeCondition = (conditionCode) => {
    const condition = conditions.find((c) => c.code === conditionCode);

    changeCondition(condition);
  };

  return (
    <Form autoComplete="off" error={firstError(saveErrors) !== null}>
      {hasConditions && (
        <DatasetConditionsDropdown
          changeCondition={onChangeCondition}
          conditions={conditions}
          isNew={isNew}
          readStatus={readStatus}
          saveErrors={saveErrors}
          saveStatus={saveStatus}
          selectedCondition={selectedCondition}
        />
      )}
      {hasConditions && FieldComponent && (<FieldComponent />)}
      {!hasConditions && (<NoRows entity="conditions" className="min-h-220" />)}
    </Form>
  );
};

const mapStateToProps = ({
  datasetConditions: {
    activeCondition,
    conditions,
    datasetConditions,
  },
}) => {
  const filtered = availableDatasetConditions(datasetConditions, conditions, activeCondition);

  return {
    selectedCondition: filtered.datasetCondition.condition,
    conditions: filtered.conditions,
    isNew: activeCondition.isNew,
    readStatus: conditions.readStatus,
    saveErrors: activeCondition.saveErrors,
    saveStatus: activeCondition.saveStatus,
  };
};

const mapDispatchToProps = {
  fetchData: fetchConditions,
  changeCondition: updateActiveDatasetCondition,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetConditionForm);
